import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`attribute?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`attribute/${id}`);
    },
    create(data) {
        return Api().post(`attribute`, data);
    },
    update(data) {
        return Api().put(`attribute/${data.id}`, data);
    },
    delete(id) {
        return Api().delete(`attribute/${id}`);
    }
}